module.exports = __webpack_public_path__ + "static/img/f2.f098530.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/center/dam/f2.png
// module id = OHQH
// module chunks = 0